import { Pipe, PipeTransform } from '@angular/core';
import { Attachment } from 'common/store/genesys-cloud/conversations/emails/models/attachment.model';
import { EmailMessage } from 'common/store/genesys-cloud/conversations/emails/models/email-message.model';

@Pipe({
  name: 'gcEmailBody'
})
export class EmailBodyPipe implements PipeTransform {
  transform(email: EmailMessage): string {
    if (email.htmlBody) {
      return this._replaceInlineAttachments(email.attachments, email.htmlBody);
    }

    return `<pre>${email.textBody}</pre>`;
  }

  private _replaceInlineAttachments(attachments: Attachment[], htmlBody: string): string {
    return attachments
      .filter((a) => a.inlineImage)
      .reduce(
        (prev, curr) =>
          prev.replace(new RegExp('cid:' + curr.attachmentId.replace('@', '&#64;'), 'g'), curr.contentUri),
        htmlBody
      );
  }
}
